import React, { useRef, useState } from "react";
import { motion, useDragControls } from "framer-motion";
import "./styles/DraggablePublishModal.css";

const DraggablePublishModal = ({ children, onClose }) => {
  const constraintsRef = useRef(null);
  const dragControls = useDragControls();
  const [pointerDown, setPointerDown] = useState(false);

  return (
    <div className="modal-backdrop" ref={constraintsRef}>
      <motion.div
        className="modal-window"
        drag
        dragControls={dragControls}
        dragListener={false}
        dragMomentum={false}
        dragElastic={0.2}
        dragConstraints={constraintsRef}
        dragTransition={{ bounceStiffness: 600, bounceDamping: 15 }}
        onDragStart={() => setPointerDown(true)}
        onDragEnd={() => setPointerDown(false)}
        initial={{ opacity: 0, scale: 0.95, y: -20 }}
        animate={{ opacity: 1, scale: pointerDown ? 0.98 : 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        transition={{ duration: 0.25, ease: "easeInOut" }}
        style={{
          margin: "0 auto",
        }}
      >
        <motion.div
          className="modal-header"
          onPointerDown={(e) => dragControls.start(e)}
          style={{ cursor: pointerDown ? "grabbing" : "grab" }}
        >
          <span>⠿ Новая публикация</span>
          <div className="window-controls">
            <button className="modal-header-button" onClick={onClose}>
              ✖
            </button>
          </div>
        </motion.div>
        <div className="publish-modal-content">{children}</div>
      </motion.div>
    </div>
  );
};

export default DraggablePublishModal;
